export default __webpack_public_path__ + "static/media/sounds/rct_accuracy_question_instruction.mp3";